<template>
  <div class="tab_container">
    <div id="tab1" class="tab_content" style="height:306px;">
      <!-- Tab -->
      <div class="tab_incon">
        <div v-for="(notice,index) in topNotice" v-if="index < 4" :key="notice.id">
          <div class="fix"></div>
          <div class="list">
            <a :target="target(notice)" :href="href(notice)" @click="pushToNewsSub(notice, $event)">
              <div style="border-bottom: #ccc 1px dotted;padding: 5px 0;margin-right: 6px;">
                <div class="left">{{notice.createdAt.split(' ')[0]}}</div>
                <div class="right" style="height: 20px;line-height: 20px;overflow: hidden"><span class="nhott">HOT</span>{{notice.title}}</div><img src="/../static/images/stickyPin.png">
                <div class="fix"></div>
              </div>
            </a>
          </div>
        </div>
        <div v-for="(notice,index) in normalNotices" :key="notice.id">
          <div class="fix"></div>
          <div class="list">
            <a :target="target(notice)" :href="href(notice)" @click="pushToNewsSub(notice, $event)">
              <div style="border-bottom: #ccc 1px dotted;padding: 5px 0;margin-right: 6px;">
                <div class="left">{{notice.createdAt.split(' ')[0]}}</div>
                <div class="right" style="height: 20px;line-height: 20px;overflow: hidden">{{notice.title}}</div>
                <div class="fix"></div>
              </div>
            </a>
          </div>
        </div>
        <div class="fix"></div>
        <div class="fright mt10">
          <router-link :to="newsMoreTo" class="more_btn">more</router-link>
        </div>
        <div class="fix"></div>
      </div>
      <!-- Finish -->
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {

  name: 'tab_container',
  props: ['type', 'notices'],
  data() {
    return {
      newsitem: '',
      locale: sessionStorage.getItem('locale'),
    };
  },
  computed: {
    topNotice() {
      var arr = this.notices
      arr = arr.filter(item => {
        return (item.typeId == this.type.id || this.type.id === 0) && item.isTop && item.language.toUpperCase() === this.locale
      })
      return arr
    },
    normalNotices() {
      var arr = this.notices
      // 1. 第一階段：篩選內容 (維持原本邏輯：類別、非置頂、語言)
      arr = arr.filter(item => {
        return (item.typeId == this.type.id || this.type.id === 0) && 
              !item.isTop && 
              item.language.toUpperCase() === this.locale
      })
      // 2. 第二階段：數量截斷 (總數維持 5 筆)
      // 計算邏輯：目標 5 筆 - 目前置頂的數量
      var limit = 5 - this.topNotice.length
      return arr.slice(0, Math.max(0, limit))
    },
    newsMoreTo() {
      const to = { name: 'news' }
      if (sessionStorage.getItem('locale') === 'EN') to.query = { L: 'EN' }
      return to
    }
  },
  methods: {
    pushToNewsSub(newsitem, event) {
      if (!newsitem || newsitem.linkType !== 1) return;
      if (event && event.preventDefault) event.preventDefault();
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href(newsitem) {
      if (!newsitem) return undefined;
      if (newsitem.linkType === 2 && newsitem.externalLink)
        return newsitem.externalLink;
      if (newsitem.linkType === 1) {
        const to = { name: 'news_sub', params: { newsid: newsitem.id } }
        if (sessionStorage.getItem('locale') === 'EN') to.query = { L: 'EN' }
        return this.$router.resolve(to).href
      }
      return undefined;
    },
  }
};

</script>
<style lang="scss" scoped>
#teacher_agent {

  table,
  th,
  td {
    padding: 10px;
    border: 1px solid #bbb;
    border-collapse: collapse;

    td {
      &:first-child {
        text-align: center;
      }
    }

    label {
      margin-right: 6px;

      input {
        margin-right: 4px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// HomeNotice.vue?966808a8